import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';

const ExistingUserSurveysQuery = async (user_uuid=null) => (
  await Query(`
    {
      users_career_clusters_surveys(${jsonToInputParams({user_uuid, limit: 2})}) {
       id,
       updated_at,
       category {
         id
         title
       }
       response_store {
         answered_questions
         cluster_weights
       }
      }
    }
  `)
);

export default ExistingUserSurveysQuery;
